
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';

export default {
  name: 'about-map',
  mixins: [sulu],
};
